import { dayjs } from '@frontend/duck-tape';
import type { TrackingReduxState } from '@frontend/redux/slices/trackingSlice';
import * as TrackingSlice from '@frontend/redux/slices/trackingSlice';
import { useDispatch } from 'react-redux';
import { useSelector } from './useSelector';

export const useTrackingSlice = <TRootState extends { tracking: TrackingReduxState }>() => {
  const tracking = useSelector<TRootState>()(({ tracking }) => tracking);
  const dispatch = useDispatch();

  const setIrClickId = (irClickId: string) => dispatch(TrackingSlice.setIrClickId(irClickId));
  const setImRef = (imRef: string) => dispatch(TrackingSlice.setImRef(imRef));
  const clearTracking = () => dispatch(TrackingSlice.clearTracking());

  const getValidImRef = () => {
    if (!tracking || !tracking.imRef || !tracking.imRefTimestamp) return undefined;
    const isExpired = dayjs().diff(dayjs(tracking.imRefTimestamp), 'day') >= 30;

    if (isExpired) {
      dispatch(TrackingSlice.clearExpiredImRef());
      return undefined;
    }

    return tracking.imRef;
  };

  const getValidIrClickId = () => {
    if (!tracking || !tracking.irClickId || !tracking.irClickIdTimestamp) return undefined;
    const isExpired = dayjs().diff(dayjs(tracking.irClickIdTimestamp), 'day') >= 30;

    if (isExpired) {
      dispatch(TrackingSlice.clearExpiredIrClickId());
      return undefined;
    }

    return tracking.irClickId;
  };

  return {
    clearTracking,
    imRef: getValidImRef(),
    irClickId: getValidIrClickId(),
    setImRef,
    setIrClickId,
  };
};
